import { Box, Flex, Headline, Text, Image, mediaQueries, Button, theme } from '@lce/slice';
import styled from 'styled-components';
import ChevronUp from './assets/chevron-up.svg';
import ChevronDown from './assets/chevron-down.svg';
import { pizzaImage } from './assets/pizzaImage';

interface IDirection {
  isLeft: boolean;
}

interface IShowLegal {
  showLegal: boolean;
}

export const DealTile = styled(Box)`
  width: 100%;
  padding: 8px;
  max-width: 500px;
  margin: 0 auto;

  ${mediaQueries[2]} {
    padding: initial;
    width: 500px;
  }
`;

export const TopBorder = styled(Flex)`
  align-items: center;
  justify-content: space-between;
`;

export const TopBorderWrapper = styled(Box)`
  background-image: url(${pizzaImage});
  background-repeat: round;
  width: 100%;
  height: 16px;

  ${mediaQueries[1]} {
    height: 16px;
  }

  ${mediaQueries[2]} {
    height: 17px;
  }
`;

export const DealCategory = styled(Box).attrs({
  m: '0 10px',
})`
  background-color: ${() => theme.colors.black};
  clip-path: polygon(10% 0%, 90% 0%, 100% 35%, 100% 55%, 90% 88%, 10% 88%, 0 53%, 0 36%);
  height: 36px;
  width: 100%;

  ${mediaQueries[1]} {
    clip-path: polygon(10% 0%, 90% 0%, 100% 35%, 100% 55%, 90% 88%, 10% 88%, 0 53%, 0 36%);
    height: 36px;
  }

  ${mediaQueries[2]} {
    clip-path: polygon(6% 0%, 94% 0%, 100% 35%, 100% 65%, 94% 100%, 7% 100%, 0 65%, 0 39%);
    height: 30px;
  }
`;

export const DealCategoryName = styled(Text).attrs({
  fontSize: [3, 3, 4],
  textAlign: 'center',
  py: ['6px', '6px', '3px'],
})`
  font-family: ${() => theme.fonts.mrEaves};
  color: ${() => theme.colors.white};
  font-weight: bold;
  text-transform: uppercase;

  @media screen and (min-width: 276px) and (max-width: 358px) {
    padding: 7px 0;
    font-size: 10px;
  }
`;

export const SideBorder = styled(Box)<IDirection>`
  background-image: url(${pizzaImage});
  background-repeat: round;
  display: flex;
  flex-direction: column;
  align-items: ${({ isLeft }) => (isLeft === true ? 'flex-start' : 'flex-end')};
  width: 17px;
  height: auto;
  margin-top: -10px;

  ${mediaQueries[1]} {
    width: 17px;
    margin-top: -10px;
  }

  ${mediaQueries[2]} {
    width: 18px;
    margin-top: -6px;
  }
`;

export const ImageWrapper = styled(Box)`
  text-align: center;
`;

export const CouponCodeProductImage = styled(Image)`
  width: 98px;
  height: 65px;

  ${mediaQueries[1]} {
    width: 98px;
    height: 65px;
  }

  ${mediaQueries[2]} {
    width: 163px;
    height: 108px;
  }
`;

export const BodyWrapper = styled(Flex)`
  min-height: 'initial';
  flex-direction: column;
  justify-content: space-evenly;

  ${mediaQueries[2]} {
    min-height: 206px;
  }
`;

export const FooterWrapper = styled(Flex)<IShowLegal>`
  min-height: 'initial';
  flex-direction: column;
  justify-content: space-evenly;

  ${mediaQueries[2]} {
    min-height: ${({ showLegal }) => showLegal ? '178px' : '0px'};
  }
`;

export const DealInfoWrapper = styled(Flex)`
  text-align: center;
  justify-content: space-evenly;
  flex-direction: column;
`;

export const DealTitle = styled(Headline).attrs({
  fontSize: [8, 8, 10],
  textAlign: 'center',
})`
  color: ${({ theme }) => theme.colors.orange};
  margin: 0;
`;

export const DealSubTitle = styled(Text).attrs({
  fontSize: ['18px', '18px', 6],
  textAlign: 'center',
  lineHeight: 1,
})`
  color: ${() => theme.colors.orange};
  font-family: ${() => theme.fonts.mrEaves};
  font-weight: bold;
  margin-bottom: 16px;
`;

export const DealInfo = styled(Text).attrs({
  fontSize: ['10px', '10px', '14px'],
  textAlign: 'center',
})`
  font-family: ${() => theme.fonts.mrEaves};
  font-weight: bold;
`;

export const CodeWrapper = styled(Flex)`
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
`;

export const DealCode = styled(Text).attrs({
  pb: '2px',
  textAlign: 'center',
  fontSize: ['20px', '26px', '36px'],
})`
  line-height: 1;
  font-weight: bold;
  align-self: flex-end;
  transform: translateY(-10px);
  font-family: ${({ theme }) => theme.fonts.mrEaves};

  @media screen and (min-width: 320px) and (max-width: 340px) {
    font-size: 16px
  }
`;

export const Line = styled(Box)`
  width: 1px;
  height: 52px;
  margin: 0 14px;
  border-right: 1px solid #979797;

  ${mediaQueries[1]} {
    margin: 0 8px;
  }

  ${mediaQueries[2]} {
    margin: 0 14px;
  }

  @media screen and (min-width: 320px) and (max-width: 390px) {
    margin: 0 8px;
  }
`;

export const ApplyCode = styled(Button).attrs({
  py: '12px',
  px: [1, 1, 5],
  lineHeight: ['11px', '11px', '6px'],
  alignSelf: ['flex-end', 'flex-end', 'center']
})`
  font-size: 16px;
  white-space: nowrap;

  @media screen and (min-width: 320px) and (max-width: 390px) {
    font-size: 12px;
  }
`;

export const DealFooter = styled(Flex).attrs({
  justifyContent: 'space-between',
})``;

export const OfferExpiration = styled(Text).attrs({
  fontSize: ['11px', '11px', 3],
})`
  font-weight: bold;
  font-family: ${() => theme.fonts.roboto};
`;

export const ReadMoreSection = styled(Flex).attrs({
  backgroundColor: 'white',
  padding: 0,
})`
  border: none;
  &:hover {
    cursor: pointer;
  }
`;

export const ReadMore = styled(Text).attrs({
  fontSize: [3],
})`
  font-weight: bold;
  color: ${() => theme.colors.orange};
  font-family: ${() => theme.fonts.roboto};
`;

export const UpArrow = styled(ChevronUp)`
  display: inline-block;
  height: 12px;
  width: 13px;
`;

export const DownArrow = styled(ChevronDown)`
  display: inline-block;
  height: 12px;
  width: 13px;
`;

export const LegalWrapper = styled(Box)`
  min-height: 'initial';
`;

export const Disclaimer = styled(Text).attrs({
  fontSize: [3],
  m: ['4px 0px', 0],
})`
  line-height: 1.2;
`;

export const BottomBorder = styled(Box)`
  background-image: url(${pizzaImage});
  background-repeat: round;
  width: 100%;
  height: 16px;

  ${mediaQueries[1]} {
    height: 16px;
  }

  ${mediaQueries[2]} {
    height: 17px;
  }
`;
